export const isLatestTos = (userTosVersion?: string, latestTosVersion?: string) => {
    if (!userTosVersion || !latestTosVersion) {
        return false;
    }

    return userTosVersion === latestTosVersion;
};
